module.exports = __webpack_public_path__ + "static/media/openai.c59e298f.webp";